import React from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Container,
  Card,
  useMediaQuery,
  
} from '@mui/material';
import Carousel from 'react-material-ui-carousel';

// Import the images
import image1 from '../../assets/1.png';
import image2 from '../../assets/2.png';
import image3 from '../../assets/3.png';

const Banner = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const carouselItems = [
    { image: image1 },
    { image: image2 },
    { image: image3 }
  ];

  return (
    <Box sx={{ 
      bgcolor: 'transparent', 
      color: 'black',
     pt: { xs: 2, md: 0 },
      pl: { xs: 0, md: 0 ,lg: 2,xl: 8},
      pr: { xs: 0, md: 0 ,lg: 2,xl: 8},
      position: 'relative',
    }}>
      <Container maxWidth="xxl" sx={{ position: 'relative', zIndex: 2 }}>
        <Carousel
          animation="slide"
          interval={5000}
          navButtonsProps={{
            style: {
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '50%',
              color: '#333',
              padding: '10px',
              transform: 'scale(1.2)',
              transition: 'all 0.3s ease',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 1)',
              }
            }
          }}
          navButtonsWrapperProps={{
            style: {
              bottom: 'unset',
              top: '50%',
              transform: 'translateY(-50%)',
            }
          }}
          indicatorContainerProps={{
            style: {
              gap: '8px',
            }
          }}
          indicatorIconButtonProps={{
            style: {
              color: theme.palette.primary.main,
              padding: '5px',
              transition: 'all 0.3s ease',
            }
          }}
          activeIndicatorIconButtonProps={{
            style: {
              color: theme.palette.secondary.main,
              transform: 'scale(1.2)',
            }
          }}
        >
          {carouselItems.map((item, index) => (
            <Card key={index} sx={{ 
              borderRadius: { xs: '16px', md: '24px' },
              position: 'relative',
              overflow: 'hidden',
              mt: { xs: 0, md: 0, lg: 2, xl: 4 },
              '&::before': {
                content: '""',
                display: 'block',
                paddingTop: { xs: '56.25%', md: '35%', lg: '32%' },
              },
              width: '100%',
              maxWidth: { xs: '100%', md: '1200px', lg: '1400px', xl: '1600px' },
              // boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
            }}>
              {/* Background Image */}
              <Box
                component="img"
                src={item.image}
                alt={`Banner ${index + 1}`}
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  zIndex: 1,
                }}
              />
            </Card>
          ))}
        </Carousel>
      </Container>
    </Box>
  );
};

export default Banner; 